module.exports = __webpack_public_path__ + "static/media/logo.c8658217.png";